import { useEffect, useState } from 'react';
import { SimpleGrid, Spinner, Center } from '@chakra-ui/react';
import StatCard from './StatCard';
import { FiUsers } from 'react-icons/fi';
import axios from 'axios';
import baseUrl from 'Base_Url/baseUrl';

const iconMap = {
  'Active Talatics': FiUsers,
};

const colorMap = {
  'Active Talatics': {
    bgColor: '#e0f7fa',
    color: '#00695c',   
  },
};

const ActiveTalatics = () => {
  const [stats, setStats] = useState([]);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem('token');

  // const fetchStats = async () => {
  //   try {
  //     const response = await axios.get(`${baseUrl}/dashboard/active-talatis`, {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //       },
  //     });

  //     if (response.status === 200) {
  //       const { talatics } = response.data.data;

  //       const formattedStats = [
  //         {
  //           label: 'Active Talatics',
  //           count: talatics,
  //           icon: iconMap['Active Talatics'],
  //           ...colorMap['Active Talatics'],
  //         },
  //       ];

  //       setStats(formattedStats);
  //     }
  //   } catch (error) {
  //     console.error('Error fetching active talatics:', error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // useEffect(() => {
  //   fetchStats();
  // }, []);

  if (loading) {
    return (
      <Center h="150px">
        <Spinner size="lg" />
      </Center>
    );
  }

  return (
    <SimpleGrid columns={{ base: 1, sm: 2, md: 2, lg: 4 }} spacing="6" mb="10">
      {stats.map((stat, index) => (
        <StatCard key={index} {...stat} />
      ))}
    </SimpleGrid>
  );
};

export default ActiveTalatics;
